import { BreadCrumbs } from '@app/components/BreadCrumbs';
import { Layout } from '@app/components/Layout';
import { useAuth } from '@app/hooks/useAuth';
import { Stack } from '@mui/material';
import { Actions } from './Actions';
import { Tables } from './Tables';

export function Professors() {
  const { isAdmin } = useAuth();

  return (
    <Layout>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <BreadCrumbs
          links={[
            {
              label: 'Dashboard',
              link: '/',
            },
            {
              label: 'Staff',
              link: '/users/staff',
            },
          ]}
        />
        {isAdmin && <Actions />}
      </Stack>
      <Tables />
    </Layout>
  );
}
